import cn from 'clsx'
import { useDispatch } from 'react-redux'

// Actions
import { actions as browseActions } from 'modules/browse/actions'

// Hooks
import { useCurrentQuery } from 'modules/browse/hooks'

// Types
import { QueryObject } from 'types'

// Utils
import { isBrowser } from '@process'

import styles from './sortmode.css'

type SortModeSelectProps = {
  sortModes: Array<{ value: number; name: string }>
  currentQuery: QueryObject
}

export const SortModeSelect = ({ sortModes, currentQuery }: SortModeSelectProps): JSX.Element => {
  const dispatch = useDispatch()
  const handleChange = ({ target: { value } }: React.ChangeEvent<HTMLSelectElement>) => {
    const parsedValue = +value
    const { ordering, ...currentQueryWithoutOrder } = currentQuery // eslint-disable-line
    dispatch(
      browseActions.updateSearchWithQuery({
        ...currentQueryWithoutOrder,
        ...(parsedValue !== 1 ? { ordering: parsedValue } : {}),
      }),
    )
  }
  return (
    <select
      value={currentQuery.ordering || 0}
      className={styles.sortSelect}
      onChange={handleChange}
      id="sortModeSelect"
      name="sortModeSelect"
      datatesting="sortby_select"
      // NOTE(Kitti): If text search then sorting is always by relevance
      disabled={!isBrowser || !!currentQuery.q}
    >
      {sortModes?.map(({ value, name }) => (
        <option key={String(value)} value={value}>
          {name}
        </option>
      ))}
    </select>
  )
}

type SortModeProps = {
  sortModes: Array<{ value: number; name: string }>
  className?: string
}

const SortMode = ({ sortModes, className }: SortModeProps): JSX.Element => {
  const currentQuery = useCurrentQuery()
  return (
    <div className={cn(styles.wrapper, className)}>
      <label className={cn(currentQuery.q && styles.disabled)} htmlFor="sortModeSelect">
        Sort by:
      </label>
      <SortModeSelect sortModes={sortModes} currentQuery={currentQuery} />
    </div>
  )
}

export default SortMode
